import useMediaQuery from '@mui/material/useMediaQuery'
import { DESKTOP_NAV_QUERY } from './chromeSx'

/** True when the logged-in nav is a permanent Drawer (md+). */
export default function useDesktopNav() {
  return useMediaQuery(DESKTOP_NAV_QUERY, { noSsr: true })
}
